import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, ManagedUnitReducer, ManagedUnitState } from './managed-unit-reducer';


const ManagedUnitContext = createContext<ManagedUnitState | undefined>(undefined);
const QuestionAnwserContextDispatchContext = createContext({} as any);

const initialState: ManagedUnitState = {
    managedUnit: []
};

const ManagedUnitProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(ManagedUnitReducer, initialState);

    return (
        <ManagedUnitContext.Provider value={state}>
            <QuestionAnwserContextDispatchContext.Provider value={dispatch}>
                {children}
            </QuestionAnwserContextDispatchContext.Provider>
        </ManagedUnitContext.Provider>
    );
}

const useManagedUnitState = () => {
    const context = useContext(ManagedUnitContext);
    if (context === undefined) {
        throw new Error('useManagedUnitState must be used within a HomeProvider');
    }
    return context;
}

const useManagedUnitDispatch = () => {
    const context = useContext(QuestionAnwserContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { ManagedUnitProvider, useManagedUnitState, useManagedUnitDispatch, ACTION_TYPES };

